export enum IdentifierTypeEnum {
  Phone = "phone",
  Email = "email",
}

export enum PurposeEnum {
  Register = "register",
  ResetPwd = "reset_pwd",
  Login = "login",
}

export enum LoginEnum {
  Token = "token",
}
